import React, { useEffect, useReducer, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import {
    Grid,
    Paper,
    CssBaseline,
    Typography,
    InputAdornment,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import LockIcon from "@material-ui/icons/Lock";
import { makeStyles } from "@material-ui/core/styles";
import loginService from "./loginService";
import icon_brazil from "../../images/icon_brazil.png";
import icon_uk from "../../images/icon_uk.png";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import DefaultButton from "../../componentes/button/DefaultButton";
import InputField from "../../componentes/form-fields/InputField/InputField";
import ClientLogo from "../../images/logo.png";
import LoginBackground from "../../images/loginBackground.jpg";
import "./Login.scss"
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { useTheme } from "../../configurations/themeProvider";

const useStyles = makeStyles((theme) => ({
    icon: {
        color: "#71777B",
        fontSize: 30,
    },
    image: {
        backgroundImage: `url(${LoginBackground})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
    },
    logo: {
        margin: theme.spacing(8, 0, 0, 0),
        [theme.breakpoints.only("xs")]: {
            margin: theme.spacing(8, 0, 4, 0),
        },
    },
    paper: {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100vh",
        margin: theme.spacing(0, 8, 0, 8),
        maxWidth: 400,
        [theme.breakpoints.only("xs")]: {
            margin: theme.spacing(0, 4, 0, 4),
        },
    },
}));


function reducer(state, action) {
    switch (action.type) {
        case 'update':
            return { ...state, ...action.data }
        case "clear":
            return initialUserState
        case "error":
            return { ...state, error: true, }
        default:
            return new Error();
    }
}

const initialUserState = {
    username: "",
    currentPassword: "",
    error: false,
};

export default function Login() {
    //Used to translate the app
    const { t, i18n } = useTranslation();
    const changeLanguage = (response) => {
        if (response != null && typeof response === "string") {
            i18n.changeLanguage(response);
            sessionStorage.setItem("language", response);

        } else if (response.target.value != null && response.target.value != "") {

            setLanguageValue(response.target.value);

            i18n.changeLanguage(response.target.value);
            sessionStorage.setItem("language", response.target.value);
        } else {
            i18n.changeLanguage("ptBR");
            sessionStorage.setItem("language", "ptBR");
        }
    };

    const classes = useStyles();
    const history = useHistory();
    const { control, handleSubmit } = useForm();

    const [user, dispatch] = useReducer(reducer, initialUserState);
    const { username, currentPassword, error } = user
    const [languageValue, setLanguageValue] = useState("")

    const { theme, toggle } = useTheme();

    //load the list of system parameters in session storage
    useEffect(() => {
        loginService.getSystemParameterList().then((response) => {
            sessionStorage.setItem("parameterList", JSON.stringify(response.data));
            response.data.map((item) => {
                if (item.parameter === "DEFAULT_LANGUAGE") {
                    changeLanguage(item.textValue)
                    setLanguageValue(item.textValue)
                }
            })
        });
    }, []);

    const handleChange = ({ target: { name, value } }) => {
        dispatch({
            type: 'update',
            data: { [name]: value }
        })
    };

    const handleLogin = () => {
        const { error, ...data } = user
        loginService
            .login(data)
            .then((response) => {
                if (response.status === 200) {

                    //Saves the user information on session storage for later use
                    sessionStorage.setItem("token", response.data.jwtToken);
                    sessionStorage.setItem("userId", response.data.id);
                    sessionStorage.setItem("username", response.data.username);
                    sessionStorage.setItem("role", response.data.role);
                    sessionStorage.setItem("blocked", response.data.blocked);
                    sessionStorage.setItem("status", response.data.status);
                    sessionStorage.setItem(
                        "roleDescription",
                        response.data.roleDescription
                    );
                    sessionStorage.setItem("userImage", response.data.base64Image);

                    sessionStorage.setItem("versionNumber", response.data.versionNumber);



                    if (response.data.firstAccess !== 1) {
                        history.push("/change-password");
                    } else {
                        history.push("/home");
                    }
                } else {
                    dispatch({
                        type: 'error'
                    })
                }
            })
            .catch((e) => {
                dispatch({
                    type: 'error'
                })
            });
    };

    return (
        <Grid container component="main" className={"root"}>
            <CssBaseline />
            <Grid
                item
                xs={12}
                sm={8}
                md={6}
                component={Paper}
                elevation={6}
                square
                className={"paperBackground"}
            >
                <div className={classes.paper}>
                    <img src={ClientLogo} className={classes.logo} />
                    <div>
                        <form onSubmit={handleSubmit(handleLogin)}>
                            {error && (
                                <Typography align="center" style={{ color: "red" }}>
                                    {t("loginError")}
                                </Typography>
                            )}
                            <InputField
                                name="username"
                                control={control}
                                defaultValue={""}
                                onChange={handleChange}
                                value={username}
                                length={50}
                                label={t("username")}
                                inputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">{<AccountCircleIcon className={classes.icon} />}</InputAdornment>
                                    ),
                                }}
                            />
                            <InputField
                                name="currentPassword"
                                control={control}
                                defaultValue={""}
                                onChange={handleChange}
                                value={currentPassword}
                                length={50}
                                label={t("password")}
                                type="password"
                                inputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">{<LockIcon className={classes.icon} />}</InputAdornment>
                                    ),
                                }}
                            />
                            <DefaultButton
                                className={"submit"}
                                onClick={handleLogin}
                                content={t("loginButton")}
                                submit
                            />

                            {/* <Grid item style={{ paddingTop: "10px" }}>
                                <DefaultAutocomplete
                                    name={"languageValue"}
                                    onChange={changeLanguage}
                                    value={languageValue}
                                    label={t("location")}
                                    defaultSize
                                    useImage
                                    items={[
                                        { id: 'ptBR', name: "Portuguese", img: icon_brazil, status: 1 },
                                        { id: 'en', name: "English", img: icon_uk, status: 1 },
                                    ]}
                                />
                            </Grid> */}
                        </form>
                    </div>
                    <IconLabelSwitch style={{ margin: "10px" }} name={"copyRight"} labelName={"copyRight"} />
                </div>
            </Grid>
            <Grid item xs={false} sm={4} md={6} className={classes.image} />
        </Grid>
    );
};

//END - LCoelho - 29/04/2021 - Initial development
